import { FC, useEffect, useState } from 'react';
import { Alert, Box, Button } from '@mui/material';
import { authService } from '../../Services/AuthService';

const Login: FC = () => {
  const [failed, setFailed] = useState(false);
  const login = () => {
    setFailed(false);
    void authService.login().catch(() => setFailed(true));
  };
  useEffect(() => {
    login();
  }, []);

  return failed ? <Box sx={{ p: 3 }}>
    <Alert severity="error">Ekki tókst að opna innskráningu. Reyndu aftur.</Alert>
    <Button onClick={login} sx={{ mt: 2 }}>Reyna aftur</Button>
  </Box> : null;
};

export default Login;
